import React from 'react';

const style = { display: 'block', fontSize: '10px', color: '#64748b', lineHeight: 1.4 };

export default function ChecklistLinkDate({ createdAt }) {
  const date = createdAt ? new Date(createdAt) : null;
  if (!date || Number.isNaN(date.getTime())) {
    return <span style={style}>Brak zapisanej daty</span>;
  }
  return (
    <time dateTime={date.toISOString()} style={style} title={date.toLocaleString('pl-PL', { timeZoneName: 'short' })}>
      Dodano: {date.toLocaleString('pl-PL', {
        day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
      })}
    </time>
  );
}
